/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';

import BenefitsService from 'src/services/benefits.service';

export const useBenefitsConfigVersion = (
  // eslint-disable-next-line no-unused-vars
  params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
    companyId: string;
    type: string;
  }
) => {
  const result = useQuery({
    queryKey: ['benefits-config-version'],
    queryFn: () => BenefitsService.getBenefitsConfigVersion(params),

    enabled: true,
  });
  return result;
};
